export class CustomerNetList {    
    private params: any = {};

    activate(params) {        
        this.params.Id = params.Id
    }
}